/** Use for lending yield endpoints. */
export const LENDING_PROTOCOLS = ['aave', 'compound', 'morpho', 'hyperlend'];
/** Use for vault yield endpoints. */
export const VAULT_PROTOCOLS = ['beefy', 'yearn', 'pendle', 'hyperliquid'];
/** Use for staking yield endpoints. */
export const STAKING_PROTOCOLS = ['lido', 'rocketpool', 'jito', 'marinade'];
/** Use when you need the full set of lending and vault yield protocols. */
export const ALL_YIELD_PROTOCOLS = [...LENDING_PROTOCOLS, ...VAULT_PROTOCOLS];
/** Use for endpoints that return pool or share prices. */
export const PRICE_YIELD_PROTOCOLS = ['aave', 'morpho', 'pendle', 'midas'];
/** Use when pool ids are onchain addresses instead of simple names. */
export const ADDRESS_POOL_PROTOCOLS = ['compound', 'morpho', 'hyperlend', 'yearn', 'pendle'];
